/**
 * Аналитика — только анонимные агрегаты (ADR 0015): события без ID, без
 * координат, без cookie. Маячок «маршрут построен» — venue × цель × час,
 * nginx отвечает 204 и пишет строку в отдельный лог; больше сервер не знает
 * ничего. DNT уважается. Любая ошибка — молчание (аналитика не смеет мешать).
 */

/** Пользователь попросил не отслеживать — не шлём даже анонимное. */
function dntEnabled(): boolean {
  return navigator.doNotTrack === '1'
}

/** «Маршрут построен»: превью показано пользователю (спека 03). */
export function reportRouteBuilt(venueId: string, targetId: string): void {
  report(venueId, 'route_built', targetId)
}

/**
 * Скан QR: открытие с `?a={anchor}` — единственный сигнал полевого теста
 * «сколько людей реально сканируют щиты». Ключ агрегата — id якоря
 * (какой щит работает); координат и идентификаторов нет (ADR 0015).
 */
export function reportScan(venueId: string, anchorId: string): void {
  report(venueId, 'scan', anchorId)
}

/** Успешный выбор из поиска: что ищут и находят (владелец видит спрос). */
export function reportSearchPick(venueId: string, targetId: string): void {
  report(venueId, 'search_top', targetId)
}

/**
 * «Не нашли» — leasing-инсайт владельцу (ADR 0014). Свободный текст запроса
 * усечён до 32 симв. и нормализован — этого достаточно для агрегата.
 */
export function reportSearchMissed(venueId: string, query: string): void {
  const key = query.toLowerCase().trim().slice(0, 32)
  if (key.length >= 2) report(venueId, 'search_missed', key)
}

/**
 * Продвижение: показ и переход (ADR 0019). Ключ — id юнита, как у остальных
 * метрик; ни рекламодателя, ни кампании здесь нет — арендатор и так знает,
 * за какой юнит платил, а нам большего знать незачем.
 *
 * Показ считаем ОДИН РАЗ ЗА СЕССИЮ на юнит: иначе счётчик мерил бы не
 * внимание людей, а частоту перерисовки, и отчёт арендатору был бы враньём.
 */
const reportedImpressions = new Set<string>()

export function reportPromoImpression(venueId: string, unitId: string): void {
  if (reportedImpressions.has(unitId)) return
  reportedImpressions.add(unitId)
  report(venueId, 'promo_impression', unitId)
}

export function reportPromoTap(venueId: string, unitId: string): void {
  report(venueId, 'promo_tap', unitId)
}

/** Batch-контракт сервера (D3): POST /api/events {venue, events[{metric,key}]}. */
function report(venueId: string, metric: string, key: string): void {
  if (dntEnabled()) return
  const body = JSON.stringify({ venue: venueId, events: [{ metric, key }] })
  try {
    const blob = new Blob([body], { type: 'application/json' })
    if (!navigator.sendBeacon?.('/api/events', blob)) {
      void fetch('/api/events', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body,
        keepalive: true,
      }).catch(() => undefined)
    }
  } catch {
    // Никогда не мешаем пользователю из-за аналитики.
  }
}
